import { Checkbox, message, Modal, Spin } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import {
  TEntityLink,
  TLinkSource
} from "components/feature-entity-linking-page/models";
import { getFeatureDetail } from "components/feature-entity-linking-page/utils";
import { generateLinkingPayload } from "components/feature-entity-linking-page/utils/generate-payload";
import { ErrorMessages, SuccessMessages } from "constants/index";
import { ProjectContext } from "context/ProjectProvider";
import { useCIQMutation } from "hooks/ciq-gql-hooks";
import { useContext, useState } from "react";
import { MUTATION_APPLY_LINKING_CHANGES } from "services/graphQL/mutations";

export default function MaterialToMaterialTrackingCheckbox({
  selectedEntityInfo,
  list,
  refetchEntityInfo,
  checked,
  setChecked
}: {
  list: TLinkSource[];
  selectedEntityInfo: TEntityLink;
  refetchEntityInfo: () => Promise<void>;
  checked: boolean;
  setChecked: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [loading, setLoading] = useState(false);

  const { gqlClientForProject } = useContext(ProjectContext);

  const [linkingMutation] = useCIQMutation(MUTATION_APPLY_LINKING_CHANGES, {
    client: gqlClientForProject
  });

  const handleSave = async () => {
    const oldEntityLinks: TLinkSource[] = list;
    const newEntityLinks: TLinkSource[] = [];

    const payload = generateLinkingPayload({
      selectedEntityInfo: {
        ids: selectedEntityInfo.ids,
        parentFeatureDetail: getFeatureDetail(
          selectedEntityInfo.feature_type_id
        ).feature
      },
      oldEntityLinks,
      newEntityLinks,
      cardsFeatureName: "MATERIALS"
    });

    const payloadData = {
      input: {
        inserts: payload.inserts,
        deletes: payload.deletes,
        updates: []
      },
      metadata: {
        request_source: "LINKING_PAGE"
      }
    };

    const linkingResponse = await linkingMutation({
      variables: payloadData
    });

    if (linkingResponse?.data) {
      message.success(SuccessMessages.SuccessfullyUpdate);

      await refetchEntityInfo();
    } else {
      message.error(ErrorMessages.SomethingWentWrong);
    }
  };

  const toggleMaterialLinking = (e: CheckboxChangeEvent) => {
    if (!e.target.checked && list.length) {
      Modal.confirm({
        title: "Disable Linking to Materials?",
        content: "All the linked Materials will be removed.",
        className: "skip-listing-window custom-rounded-modal",
        async onOk() {
          setLoading(true);
          await handleSave();
          setChecked(false);
          setLoading(false);
        },
        okText: "Yes, Disable"
      });
    } else {
      setChecked(e.target.checked);
    }
  };

  return (
    <Spin spinning={loading}>
      <Checkbox checked={checked} onChange={toggleMaterialLinking}>
        Link Material to Materials
      </Checkbox>
    </Spin>
  );
}
